module.exports = __webpack_public_path__ + "static/media/prepaid-empty-history.43f528f5.svg";